$(document).ready(function () {

  //  START:- footer dropdown
  if ($(window).width() < 767) {
    $("footer .footer-block__heading").each(function () {
      $(this).click(function () {
        $(this).siblings(".footer-block__details-content").slideToggle();
        $(this).addClass("active");
      });
    });
  }

  // START:- home featured collection
    // Function to initialize the sliders
    function initializeSlider($slider, mobCount, deskCount) {
      var cout = deskCount;
  
      if ($(window).width() < 767) {
        cout = mobCount;
      }
  
      $slider.slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        centerMode: true,
        slidesToShow: cout,
        slidesToScroll: 1,
        centerPadding: "0px",
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: mobCount
            }
          },
          {
            breakpoint: 1201,
            settings: {
              slidesToShow: deskCount
            }
          }
        ],
      });
    }
  
    // Initialize slider for ".slider--content-wrapp"
    $(".slider--content-wrapp").each(function() {
      var $slider = $(this),
        mobCount = $slider.data("mob"),
        deskCount = $slider.data("desk");
  
      initializeSlider($slider, mobCount, deskCount);
    });
  
    // Initialize blog slider for ".blog-article-wrap"
    $(".blog-article-wrap").each(function() {
      var $slider = $(this),
        mobCount = $slider.data("mob"),
        deskCount = $slider.data("desk"),
        cout = deskCount;
  
      if ($(window).width() < 767) {
        cout = mobCount;
      }
  
      $slider.slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: cout,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: deskCount,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: mobCount
            },
          },
        ],
      });
    });
  

  // START:- product tab section
  $(document).on("click", ".tab-links a", function (e) {
    e.preventDefault();

    var currentAttrValue = $(this).attr("href");

    // Show/Hide Tabs
    $(".tab-content .tab").removeClass("active");
    $(currentAttrValue).addClass("active");

    // Change/remove current tab to active
    $(".tab-links li").removeClass("active");
    $(this).parent("li").addClass("active");
  });
  // END:- product tab section

  $(".v_tab_link").hover(
    function () {
      var $el = $(this),
        $wrap = $el.closest(".mega_menu_v2"),
        target = $el.attr("target");
      $wrap.find(".v_tab_link").removeClass("active");
      $wrap.find(".v_tab_content_wrap").hide();
      $wrap.find(`#${target}`).show();
      $el.addClass("active");
    },
    function () {}
  );


  $(document).on("click", ".add_fbt_item", function() {
    var $el = $(this),
        id = $el.attr("data-id") || null,
        data = [];
    if (id) {
        $el.addClass("loading");
        data.push({
            id: id,
            quantity: 1,
            properties: null,
        }
);
        multipleATC(data, $el);
    }
});
}); //ready

let navs = document.querySelectorAll(".header__inline-menu");
navs.forEach((nav) => {
  let items = nav.querySelectorAll("details");
  // console.log(items)
  items.forEach((item) => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item
        .querySelector(".mega-menu__list")
        .addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
  });


});




  document.addEventListener('DOMContentLoaded', function() {
    var increaseButton = document.getElementById('increase-quantity');
    var decreaseButton = document.getElementById('decrease-quantity');
    var quantityInput = document.getElementById('quantity');

    increaseButton?.addEventListener('click', function() {
      var currentValue = parseInt(quantityInput.value);
      quantityInput.value = currentValue + 1;
    });

    decreaseButton?.addEventListener('click', function() {
      var currentValue = parseInt(quantityInput.value);
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }
    });
  });
 
// Start: ATC button
function multipleATC(item_array, $btn = null) {
  var items = [];

  item_array.forEach((item) => {
      let myObj = {
          id: item.id,
          quantity: item.quantity,
          properties: item.properties,
      };
      items.push(myObj);
  });

  let formData = {
      items: items,
  };

  fetch("/cart/add.js", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
      })
      .then((response) => {
          if (!response.ok) {
              throw new Error('Network response was not ok');
          }
          return response.json();
      })
      .then((items) => {
          if ($btn) {
              $btn.removeClass("loading");
          }
          window.refreshCart();
          console.log(items);
      })
      .catch((error) => {
          console.error("Error:", error);
          if ($btn) {
              $btn.removeClass("loading");
          }
      });
}

try {
  window.refreshCart = () => {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, "text/html");
              const count = parseInt(html.querySelector("cart-drawer-items").getAttribute("item_count"));

              const selectors = [
                  "cart-drawer-items",
                  ".cart-drawer__footer",
                  ".drawer__header_wrap",
                  ".cart-free-product",
              ];
              $("button.cart__checkout-button").attr("disabled", false);

              if (count > 0) {
                  $("cart-drawer").removeClass("is-empty");
                  document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
                      bubble.classList.remove("hidden");
                  });
              } else {
                  $("cart-drawer").addClass("is-empty");
                  document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
                      bubble.classList.add("hidden");
                  });
              }

              for (const selector of selectors) {
                  const targetElement = document.querySelector(selector);
                  const sourceElement = html.querySelector(selector);
                  if (targetElement && sourceElement) {
                      targetElement.replaceWith(sourceElement);
                  }
              }

              document.querySelectorAll(".cart-count-bubble span:first-child").forEach((bubble) => {
                  bubble.innerHTML = count;
              });
              document.querySelector(".cart-count-bubble").innerHTML = count;

              console.log("Cart drawer refreshed");
          })
          .catch((e) => {
              console.error("Error refreshing cart drawer:", e);
          });
  };
} catch (err) {
  console.error("Error initializing refreshCart:", err);
}